var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "infoBox" },
    [
      _c(
        "el-drawer",
        {
          ref: "drawer",
          staticClass: "infoBox",
          attrs: {
            visible: _vm.dialogVisibleInfoData,
            title: _vm.isAtud ? "商品审核" : "商品详情",
            direction: _vm.direction,
            "custom-class": "demo-drawer",
            size: "1000px",
            "before-close": _vm.onClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibleInfoData = $event
            },
            close: _vm.onClose,
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
            },
            [
              _c("div", { staticClass: "detailHead" }, [
                _c("div", { staticClass: "acea-row row-between headerBox" }, [
                  _c("div", { staticClass: "full" }, [
                    _c("img", {
                      staticClass: "order_icon",
                      attrs: { src: _vm.formValidate.image, alt: "" },
                    }),
                    _c("div", { staticClass: "text" }, [
                      _c("div", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.formValidate.name)),
                      ]),
                      _c("div", [
                        _c("span", { staticClass: "mr20" }, [
                          _vm._v("商品ID：" + _vm._s(_vm.formValidate.id)),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm.isAtud
                    ? _c(
                        "div",
                        { staticClass: "acea-row justify-content" },
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "debounceClick",
                                  rawName: "v-debounceClick",
                                  value: function () {
                                    _vm.onSubmit("fail")
                                  },
                                  expression:
                                    "\n                () => {\n                  onSubmit('fail');\n                }\n              ",
                                },
                              ],
                              staticStyle: { "margin-left": "0" },
                              attrs: { size: "small" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.loadingBtn ? "提交中 ..." : "审核拒绝"
                                )
                              ),
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "debounceClick",
                                  rawName: "v-debounceClick",
                                  value: function () {
                                    _vm.onSubmit("success")
                                  },
                                  expression:
                                    "\n                () => {\n                  onSubmit('success');\n                }\n              ",
                                },
                              ],
                              attrs: { size: "small", type: "primary" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.loadingBtn ? "提交中 ..." : "审核通过"
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _c("ul", { staticClass: "list" }, [
                  _c(
                    "li",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.formValidate.type >= 0,
                          expression: "formValidate.type >= 0",
                        },
                      ],
                      staticClass: "item",
                    },
                    [
                      _c("div", { staticClass: "title" }, [_vm._v("商品类型")]),
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm._f("productTpyeFilter")(_vm.formValidate.type)
                          )
                        ),
                      ]),
                    ]
                  ),
                  _c("li", { staticClass: "item" }, [
                    _c("div", { staticClass: "title" }, [_vm._v("商品状态")]),
                    _c("div", { staticClass: "color-warning" }, [
                      _vm._v(_vm._s(_vm.formValidate.isShow ? "上架" : "下架")),
                    ]),
                  ]),
                  _c(
                    "li",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.formValidate.type &&
                            _vm.formValidate.type !== 0,
                          expression:
                            "!formValidate.type && formValidate.type !== 0",
                        },
                      ],
                      staticClass: "item",
                    },
                    [
                      _c("div", { staticClass: "title" }, [_vm._v("兑换积分")]),
                      _c("div", [
                        _vm._v(_vm._s(_vm.formValidate.redeemIntegral)),
                      ]),
                    ]
                  ),
                  _c("li", { staticClass: "item" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            !_vm.formValidate.type &&
                              _vm.formValidate.type !== 0
                              ? "兑换金额（元）"
                              : "商品售价"
                          ) +
                          " "
                      ),
                    ]),
                    _c("div", [_vm._v(_vm._s(_vm.formValidate.price) + "元")]),
                  ]),
                  _c(
                    "li",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.formValidate.type &&
                            _vm.formValidate.type !== 0,
                          expression:
                            "!formValidate.type && formValidate.type !== 0",
                        },
                      ],
                      staticClass: "item",
                    },
                    [
                      _c("div", { staticClass: "title" }, [
                        _vm._v("红包抵扣（元）"),
                      ]),
                      _c("div", [
                        _vm._v(_vm._s(_vm.formValidate.redPacket) + "元"),
                      ]),
                    ]
                  ),
                  _c("li", { staticClass: "item" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v(
                        _vm._s(
                          !_vm.formValidate.type && _vm.formValidate.type !== 0
                            ? "已兑换数"
                            : "销量"
                        )
                      ),
                    ]),
                    _c("div", [_vm._v(_vm._s(_vm.formValidate.sales))]),
                  ]),
                  _c("li", { staticClass: "item" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v(
                        _vm._s(_vm.formValidate.type >= 0 ? "库存" : "剩余库存")
                      ),
                    ]),
                    _c("div", [_vm._v(_vm._s(_vm.formValidate.stock))]),
                  ]),
                  _c(
                    "li",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.formValidate.type >= 0,
                          expression: "formValidate.type >= 0",
                        },
                      ],
                      staticClass: "item",
                    },
                    [
                      _c("div", { staticClass: "title" }, [_vm._v("创建时间")]),
                      _c("div"),
                    ]
                  ),
                ]),
              ]),
              _vm.formValidate.id && _vm.isShow
                ? _c(
                    "el-tabs",
                    {
                      attrs: { type: "border-card" },
                      model: {
                        value: _vm.currentTab,
                        callback: function ($$v) {
                          _vm.currentTab = $$v
                        },
                        expression: "currentTab",
                      },
                    },
                    [
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "基本信息", name: "0" } },
                        [
                          _c("div", { staticClass: "detailSection divBox" }, [
                            _c("ul", { staticClass: "list mt-16" }, [
                              _c(
                                "li",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.formValidate.categoryId,
                                      expression: "formValidate.categoryId",
                                    },
                                  ],
                                  staticClass: "item",
                                },
                                [
                                  _c("div", { staticClass: "lang" }, [
                                    _vm._v("平台商品分类："),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "value" },
                                    [
                                      _c("el-cascader", {
                                        attrs: {
                                          options: _vm.merPlatProductClassify,
                                          props: _vm.props1,
                                          "show-all-levels": false,
                                          disabled: _vm.isDisabled,
                                        },
                                        model: {
                                          value: _vm.formValidate.categoryId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formValidate,
                                              "categoryId",
                                              $$v
                                            )
                                          },
                                          expression: "formValidate.categoryId",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "li",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.formValidate.type >= 0,
                                      expression: "formValidate.type >= 0",
                                    },
                                  ],
                                  staticClass: "item",
                                },
                                [
                                  _c("div", { staticClass: "lang" }, [
                                    _vm._v("品牌："),
                                  ]),
                                  _c("div", { staticClass: "value" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.getListName(
                                            _vm.brandList,
                                            _vm.formValidate.brandId
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]
                              ),
                              _c("li", { staticClass: "item" }, [
                                _c("div", { staticClass: "lang" }, [
                                  _vm._v("商品单位："),
                                ]),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.formValidate.unitName)),
                                ]),
                              ]),
                              _c(
                                "li",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        !_vm.formValidate.type &&
                                        _vm.formValidate.type !== 0,
                                      expression:
                                        "!formValidate.type && formValidate.type !== 0",
                                    },
                                  ],
                                  staticClass: "item",
                                },
                                [
                                  _c("div", { staticClass: "lang" }, [
                                    _vm._v("兑换数量限制："),
                                  ]),
                                  _c("div", { staticClass: "value" }, [
                                    _vm._v(
                                      _vm._s(_vm.formValidate.exchangeNum)
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "li",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        !_vm.formValidate.type &&
                                        _vm.formValidate.type !== 0,
                                      expression:
                                        "!formValidate.type && formValidate.type !== 0",
                                    },
                                  ],
                                  staticClass: "item",
                                },
                                [
                                  _c("div", { staticClass: "lang" }, [
                                    _vm._v("热门推荐："),
                                  ]),
                                  _c("div", { staticClass: "value" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formValidate.isHot == 1
                                          ? "开启"
                                          : "关闭"
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _c("li", { staticClass: "item" }, [
                                _c("div", { staticClass: "lang" }, [
                                  _vm._v("排序："),
                                ]),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.formValidate.sort)),
                                ]),
                              ]),
                              _c(
                                "li",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.formValidate.type === 2,
                                      expression: "formValidate.type === 2",
                                    },
                                  ],
                                  staticClass: "item",
                                },
                                [
                                  _c("div", { staticClass: "lang" }, [
                                    _vm._v("用户申请售后："),
                                  ]),
                                  _c("div", { staticClass: "value" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formValidate.refundSwitch
                                          ? "开启"
                                          : "关闭"
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              (_vm.formValidate.type &&
                                _vm.formValidate.type !== 2) ||
                              _vm.formValidate.type === 0
                                ? _c(
                                    "li",
                                    { staticClass: "item" },
                                    [
                                      _c("div", { staticClass: "lang" }, [
                                        _vm._v("配送方式："),
                                      ]),
                                      Number(_vm.formValidate.type) > 4
                                        ? [
                                            _c(
                                              "div",
                                              { staticClass: "value" },
                                              [_vm._v("自动发货")]
                                            ),
                                          ]
                                        : [
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.formValidate.deliveryMethod.includes(
                                                        "1"
                                                      ),
                                                    expression:
                                                      "formValidate.deliveryMethod.includes('1')",
                                                  },
                                                ],
                                                staticStyle: {
                                                  color: "#303133",
                                                },
                                              },
                                              [_vm._v("商家配送")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.formValidate.deliveryMethod.includes(
                                                        "1"
                                                      ) &&
                                                      _vm.formValidate.deliveryMethod.includes(
                                                        "2"
                                                      ),
                                                    expression:
                                                      "formValidate.deliveryMethod.includes('1') && formValidate.deliveryMethod.includes('2')",
                                                  },
                                                ],
                                                staticStyle: {
                                                  color: "#303133",
                                                },
                                              },
                                              [_vm._v(" 、 ")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.formValidate.deliveryMethod.includes(
                                                        "2"
                                                      ),
                                                    expression:
                                                      "formValidate.deliveryMethod.includes('2')",
                                                  },
                                                ],
                                                staticStyle: {
                                                  color: "#303133",
                                                },
                                              },
                                              [_vm._v("到店自提")]
                                            ),
                                          ],
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "list",
                                staticStyle: { display: "block" },
                              },
                              [
                                _c("div", { staticClass: "item" }, [
                                  _c("div", { staticClass: "lang" }, [
                                    _vm._v("关键字："),
                                  ]),
                                  _c("div", { staticClass: "value" }, [
                                    _vm._v(_vm._s(_vm.formValidate.keyword)),
                                  ]),
                                ]),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.formValidate.guaranteeList,
                                        expression:
                                          "formValidate.guaranteeList",
                                      },
                                    ],
                                    staticClass: "item",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "lang line-heightOne" },
                                      [_vm._v("保障服务：")]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "value acea-row" },
                                      _vm._l(
                                        _vm.formValidate.guaranteeList,
                                        function (item) {
                                          return _c(
                                            "div",
                                            {
                                              key: item.id,
                                              staticClass: "mr20",
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "iconfont icon-ic-complete1 mr5 font14",
                                              }),
                                              _vm._v(_vm._s(item.name) + " "),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                                _c("div", { staticClass: "item" }, [
                                  _c("div", { staticClass: "lang" }, [
                                    _vm._v("商品简介："),
                                  ]),
                                  _c("div", { staticClass: "value" }, [
                                    _vm._v(_vm._s(_vm.formValidate.intro)),
                                  ]),
                                ]),
                                _c("div", { staticClass: "item" }, [
                                  _c(
                                    "div",
                                    { staticClass: "acea-row row-middle" },
                                    [
                                      _c("div", { staticClass: "lang" }, [
                                        _vm._v("封面图："),
                                      ]),
                                      _c(
                                        "div",
                                        { staticClass: "upLoadPicBox" },
                                        [
                                          _c("el-image", {
                                            staticClass: "pictrue",
                                            attrs: {
                                              src: _vm.formValidate.image,
                                              "preview-src-list": [
                                                _vm.formValidate.image,
                                              ],
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.videoLink,
                                        expression: "videoLink",
                                      },
                                    ],
                                    staticClass: "item",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "acea-row row-middle" },
                                      [
                                        _c("div", { staticClass: "lang" }, [
                                          _vm._v("主图视频："),
                                        ]),
                                        _c(
                                          "div",
                                          { staticClass: "upLoadPicBox" },
                                          [
                                            _c(
                                              "video",
                                              {
                                                staticClass: "pictrue",
                                                attrs: {
                                                  src: _vm.videoLink,
                                                  controls: "controls",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "您的浏览器不支持 video 标签。"
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c("div", { staticClass: "item" }, [
                                  _c(
                                    "div",
                                    { staticClass: "acea-row row-middle" },
                                    [
                                      _c("div", { staticClass: "lang" }, [
                                        _vm._v("轮播图："),
                                      ]),
                                      _vm._l(
                                        _vm.formValidate.sliderImages,
                                        function (item, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass: "pictrue",
                                            },
                                            [
                                              _c("el-image", {
                                                staticClass: "pictrue",
                                                attrs: {
                                                  src: item,
                                                  "preview-src-list":
                                                    _vm.formValidate
                                                      .sliderImages,
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ]),
                                _vm.formValidate.couponList &&
                                _vm.formValidate.couponList.length
                                  ? _c("div", { staticClass: "item" }, [
                                      _c(
                                        "div",
                                        { staticClass: "acea-row row-middle" },
                                        [
                                          _c("div", { staticClass: "lang" }, [
                                            _vm._v("购买回馈券："),
                                          ]),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "acea-row",
                                              staticStyle: {
                                                "margin-top": "-10px",
                                              },
                                            },
                                            [
                                              _vm._l(
                                                _vm.formValidate.couponList,
                                                function (tag, index) {
                                                  return _c(
                                                    "el-tag",
                                                    {
                                                      key: index,
                                                      staticClass: "mr10 mt10",
                                                      attrs: {
                                                        closable:
                                                          !_vm.isDisabled,
                                                        "disable-transitions": false,
                                                        effect: "plain",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(tag.name) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              _vm.formValidate.couponList
                                                .length === 0
                                                ? _c(
                                                    "span",
                                                    { staticClass: "mt10" },
                                                    [_vm._v("无")]
                                                  )
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm.formValidate.systemFormValue
                                  ? _c("div", { staticClass: "item" }, [
                                      _c(
                                        "div",
                                        { staticClass: "acea-row row-middle" },
                                        [
                                          _c("div", { staticClass: "lang" }, [
                                            _vm._v("关联表单："),
                                          ]),
                                          _c("div", [
                                            _c("iframe", {
                                              staticStyle: {
                                                width: "350px",
                                                height: "500px",
                                              },
                                              attrs: {
                                                src:
                                                  "https://" +
                                                  _vm.getFrontDomainUrl() +
                                                  "/pages/goods/systemIframe/index?id=" +
                                                  _vm.formValidate.systemFormId,
                                                frameborder: "0",
                                              },
                                            }),
                                          ]),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "规格库存", name: "1" } },
                        [
                          _c("div", { staticClass: "detailSection divBox" }, [
                            _c("ul", { staticClass: "list mt-16" }, [
                              _c("li", { staticClass: "item" }, [
                                _c("div", { staticClass: "tips tipsWidth" }, [
                                  _vm._v("商品规格："),
                                ]),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formValidate.specType
                                        ? "多规格"
                                        : "单规格"
                                    )
                                  ),
                                ]),
                              ]),
                              _c(
                                "li",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.formValidate.type >= 0,
                                      expression: "formValidate.type >= 0",
                                    },
                                  ],
                                  staticClass: "item",
                                },
                                [
                                  _c("div", { staticClass: "tips tipsWidth" }, [
                                    _vm._v("佣金设置："),
                                  ]),
                                  _c("div", { staticClass: "value" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formValidate.isSub
                                          ? "单独设置"
                                          : "默认设置"
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "li",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.formValidate.type >= 0,
                                      expression: "formValidate.type >= 0",
                                    },
                                  ],
                                  staticClass: "item",
                                },
                                [
                                  _c("div", { staticClass: "tips tipsWidth" }, [
                                    _vm._v("会员商品："),
                                  ]),
                                  _c("div", { staticClass: "value" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formValidate.isPaidMember
                                          ? "是"
                                          : "否"
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                            _c(
                              "div",
                              { staticStyle: { "margin-top": "16px" } },
                              [
                                _c(
                                  "div",
                                  { staticClass: "tips tipsWidth mb10" },
                                  [_vm._v("商品属性：")]
                                ),
                                [
                                  _c(
                                    "el-table",
                                    {
                                      staticClass: "tabNumWidth",
                                      attrs: {
                                        data: _vm.AttrValueList,
                                        size: "small",
                                      },
                                    },
                                    [
                                      _vm.manyTabDate
                                        ? _vm._l(
                                            _vm.manyTabDate,
                                            function (item, iii) {
                                              return _c("el-table-column", {
                                                key: iii,
                                                attrs: {
                                                  label:
                                                    _vm.manyTabTit[iii].title,
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (scope) {
                                                        return [
                                                          _c("span", {
                                                            staticClass:
                                                              "priceBox",
                                                            domProps: {
                                                              textContent:
                                                                _vm._s(
                                                                  scope.row[iii]
                                                                ),
                                                            },
                                                          }),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              })
                                            }
                                          )
                                        : _vm._e(),
                                      _c("el-table-column", {
                                        attrs: { label: "图片", width: "60" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "upLoadPicBox",
                                                    },
                                                    [
                                                      scope.row.image
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "pictrue tabPic",
                                                            },
                                                            [
                                                              _c("el-image", {
                                                                attrs: {
                                                                  src: scope.row
                                                                    .image,
                                                                  "preview-src-list":
                                                                    [
                                                                      scope.row
                                                                        .image,
                                                                    ],
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "upLoad tabPic",
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "el-icon-camera cameraIconfont",
                                                              }),
                                                            ]
                                                          ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2565633037
                                        ),
                                      }),
                                      _vm._l(
                                        _vm.tableAttrValue,
                                        function (item, iii) {
                                          return _c("el-table-column", {
                                            key: iii,
                                            attrs: {
                                              label:
                                                _vm.formThead[iii] &&
                                                _vm.formThead[iii].title,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            scope.row[iii] ||
                                                              "-"
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          })
                                        }
                                      ),
                                      _vm.formValidate.type >= 0
                                        ? _c("el-table-column", {
                                            attrs: {
                                              label: "商品条码",
                                              width: "100",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            scope.row.itemNumber
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              1982444816
                                            ),
                                          })
                                        : _vm._e(),
                                      _vm.formValidate.specType
                                        ? _c("el-table-column", {
                                            attrs: {
                                              label: "默认选中",
                                              width: "100",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            scope.row.isDefault
                                                              ? "是"
                                                              : "否"
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              1251742427
                                            ),
                                          })
                                        : _vm._e(),
                                      _vm.formValidate.specType
                                        ? _c("el-table-column", {
                                            attrs: {
                                              label: "是否显示",
                                              width: "100",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            scope.row.isShow
                                                              ? "显示"
                                                              : "隐藏"
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              2697430913
                                            ),
                                          })
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ],
                              ],
                              2
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "商品详情", name: "2" } },
                        [
                          _c("div", { staticClass: "detailSection divBox" }, [
                            _c("div", {
                              staticClass: "contentPic",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.formValidate.content || "无"
                                ),
                              },
                            }),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }